import React, { useEffect, useState } from "react";
import "./detailBox.css";
import PropTypes from "prop-types";
import { Collapse } from "@mui/material";
import { FiChevronDown } from "react-icons/fi";

function DetailBox({
  data = {},
  title,
  inputs = [],
  boxHeight,
  dataGetter,
  defaultExpanded = false, //default collapsed
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (dataGetter && typeof dataGetter === "function") {
      dataGetter();
    }
  }, [dataGetter]);

  const toggleExpand = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div style={{ marginBottom: "16px" }}>
      
      <div
        onClick={toggleExpand}
        style={{
          background: "#ffffff",
          borderRadius: expanded ? "12px 12px 0 0" : "12px",
          padding: "14px 18px",
          border: "1px solid #e6e9ef",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          transition: "all 0.2s ease",
        }}
      >
        <div
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#344767",
          }}
        >
          {title || "Details"}
        </div>

        <FiChevronDown
          size={18}
          style={{
            transition: "transform 0.3s ease",
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            color: "#67748e",
          }}
        />
      </div>

      {/* Content */}
      <Collapse in={expanded}>
        <div
          className="detailbox-container"
          style={{
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderTop: "none",
            height: boxHeight || "auto",
          }}
        >
          <div className="detailbox-grid">
            {inputs.map((item, index) => {
              let value = data[item.key];

              if (typeof value === "boolean") {
                value = value ? "Active" : "Inactive";
              }

              const dateFields = ["created_at", "updated_at"];

              if (dateFields.includes(item.key) && value) {
                value = new Date(value).toLocaleString();
              }

              if (!value) value = "—";

              return (
                <div className="detailbox-field" key={index}>
                  <div className="detailbox-label">{item.label}</div>

                  <div
                    className={`detailbox-value ${
                      data[item.key] === true
                        ? "status-active"
                        : data[item.key] === false
                        ? "status-inactive"
                        : ""
                    }`}
                  >
                    {value}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default DetailBox;

DetailBox.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    })
  ),
  boxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataGetter: PropTypes.func,
  defaultExpanded: PropTypes.bool,
};
